import { render, staticRenderFns } from "./activityEdit.vue?vue&type=template&id=b4fd375c&"
import script from "./activityEdit.vue?vue&type=script&lang=js&"
export * from "./activityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports